const isMapSearchLandingPage = (path: string) => {
    const landingPageRegEx = /^\/(to-rent|for-sale|new-homes)\/map\/?(\?.*)?$/;

    return landingPageRegEx.test(path);
};

const isKnownPathSegment = (segment: string): boolean => {
    const knownSegmentRegex = new RegExp(
        '^(' +
            'apartments|auction|barn-conversions|browse|bungalows|business|commercial|commercial|commercial-agents|cottages|' +
            'detached|details|developers|developments|discover|estate-agents|farms-land|find-agents|flats|for-sale|ground-floor|' +
            'home-values|hospitality|house-prices|houses|industrial-sites|land|letting-agents|map|market|new-homes|offices|' +
            'overseas|overseas|overseas-agents|' +
            'property|retail-premises|retirement|semi-detached|serviced-offices|studio|studio-flats|terraced|to-rent|' +
            '\\d-bedroom(s?)' +
            ')$'
    );

    return segment.match(knownSegmentRegex) != null;
};

export const getSearchLocationFromPath = (path?: string): string => {
    if (!path) {
        return '';
    }

    if (isMapSearchLandingPage(path)) {
        return 'uk';
    }

    /*
  Facts:
      We know the geo identifier is the last few segments of the path.
      We know after last "known" path segment from the beginning is the start of the geo identifier
  */

    // just the segments of the path
    const pathSegments = path
        .split('?')[0] // just the portion before the query character
        .replace(/^\/+/, '') // removing any lead /
        .replace(/\/+$/, '') // removing any trailing /
        .split('/'); // splitting on the internal /s

    for (let index = 0; index < pathSegments.length; index++) {
        const segment = pathSegments[index];
        // segment known?
        if (!isKnownPathSegment(segment)) {
            // add the remaining bits together...
            return pathSegments.slice(index).join('/');
        }
    }

    return path;
};
